import React from 'react';
import {ClipLoader} from 'react-spinners';

const ContentLoader_ = ({list}) => (
  <ClipLoader color="#DD3E45" size={80} speedMultiplier={1} />
)
export default ContentLoader_;
